import "./footer-style.css";
import React, {useState} from "react";
import {Copyright} from "./copyright/Copyright";
import {FooterLink} from "./footer-component/FooterLink";
import {FooterAddress} from "./footer-component/FooterAddress";
import {FooterSocial} from "./footer-component/FooterSocial";
import {FooterPolicy} from "./footer-component/FooterPolicy";

export const Footer = () => {
    return(
        <>
            <section className={'Footer'}>
                <div className={'container footer-container'}>
                    <div className={'container-wrap container-wrap__left'}>
                        <FooterLink/>
                        <FooterPolicy/>
                    </div>
                    <div className={'container-wrap'}>
                        <FooterAddress/>
                        <FooterSocial/>
                    </div>

                </div>
            </section>
            <Copyright/>

        </>

    );
}